import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * BlogRedirect component - redirects language-prefixed blog URLs to English-only version
 * Since the blog only supports English, all URLs like /es/blog or /fr/blog/article-slug
 * should redirect to /blog or /blog/article-slug respectively
 */
export function BlogRedirect(): JSX.Element {
  const location = useLocation();
  const params = useParams();

  // Remove the language prefix from the pathname
  // e.g., /es/blog/article-slug -> /blog/article-slug
  // e.g., /fr/blog -> /blog
  const pathWithoutLang = location.pathname.replace(/^\/[a-z]{2}\//, "/");
  const newPath = pathWithoutLang + location.search;

  return <Navigate to={newPath} replace />;
}
